<div class="full-details-container">
    <header class="d-flex justify-content-between align-items-center">
        <h5>Details</h5>
        <div class="header-btns d-flex">
            <button [class.active]="activeButton == HeaderButton.Details" (click)="changeActiveButton(HeaderButton.Details)">
                <img src="../../../../../assets/icons/ng_v3/map-details.svg" />
            </button>
            <button [class.active]="activeButton == HeaderButton.Sphere" (click)="changeActiveButton(HeaderButton.Sphere)">
                <img src="../../../../../assets/icons/ng_v3/map-sphere.svg" />
            </button>
        </div>
        <button class="close-btn d-flex justify-content-center align-items-center" (click)="closeModal()">
            ✖
        </button>
    </header> 
    <div [style.overflowY]="activeButton == HeaderButton.Details ? 'scroll' : 'hidden'" class="full-details-body">
        <div *ngIf="activeButton == HeaderButton.Details" class="img-container">
            <img *ngIf="building.image" src="{{ building.image }}" alt="Download icon" />
            <img class="no-img" *ngIf="!building.image" src="../../../../../assets/no-image.png" alt="Download icon" />
        </div>
        <div #streetViewContainer *ngIf="activeButton == HeaderButton.Sphere" [hidden]="!showStreetView" class="street-view-container">
        </div>
        <div *ngIf="activeButton == HeaderButton.Sphere" [style.backgroundColor]="'#000'" [hidden]="showStreetView" class="street-view-container">      
        </div>
        <div class="details">
            <div class="slrn-status-row d-flex justify-content-between align-items-center">
                <div class="bd-info d-flex justify-content-between align-items-center">
                    <div class="bd-img">
                        <img src="../../../../../assets/icons/ng_v3/map-bd-icon.svg" />
                    </div>
                    <div class="slrn">
                        <h5>Building</h5>
                        <span>{{ building.slrn | hasValue}}</span>
                    </div>
                </div>
                <div class="status d-flex align-items-center justify-content-center gap-1">
                    <img src="../../../../../assets/icons/ng_v3/active-icon.svg" />
                    <span>Active</span>
                </div>
            </div>
            <div *ngIf="activeButton == HeaderButton.Details" class="asset-details">
                <h4>Asset Details</h4>
                <div class="details-row d-flex justify-content-between align-items-center" [class.copied]="slrnCopied">
                    <span class="label">SLRN</span>
                    <div class="d-flex align-items-center justify-content-center gap-2">
                        <div><span class="value">{{ building.slrn | hasValue}}</span></div>
                        <img (click)="copySlrn()" class="copy" src="../../../../../assets/icons/ng_v3/copy-black.svg" />
                    </div>
                </div>
                <div class="details-row d-flex justify-content-between align-items-center">
                    <span class="label">Address</span>
                    <span class="value">{{ building.address | hasValue}}</span>
                </div>
                <div class="details-row d-flex justify-content-between align-items-center" [class.copied]="coordinatesCopied">
                    <span class="label">Coordinates</span>
                    <div class="d-flex align-items-center justify-content-center gap-2">
                        <div>
                            <span class="value">{{ building.latitude | hasValue}},</span>
                            <span class="value">{{ building.longitude | hasValue}}</span>
                        </div>
                        <img (click)="copyCoordinates()" class="copy" src="../../../../../assets/icons/ng_v3/copy-black.svg" />
                    </div>
                </div>
            </div>
            <div *ngIf="activeButton == HeaderButton.Details" class="connected-accounts">
                <h4>Number of Connected Accounts</h4>
                <span class="total-acc">{{ building.customers.length }}</span>
                <div class="customers-container">
                    <div class="card" *ngFor="let customer of building.customers" (click)="openCustomerDetailsPage(customer.id)">
                        <div class="card-row d-flex justify-content-between align-items-center">
                            <div class="name d-flex align-items-center gap-3">
                                <div class="letter-circle d-flex align-items-center justify-content-center">
                                    <span>{{ customer.buildingOwner.slice(0, 1) | hasValue}}</span>
                                </div>
                                <div class="customer-name d-flex align-items-center">
                                    <span>{{ customer.buildingOwner | hasValue}}</span>
                                </div>
                            </div>
                            <img height="24" width="24" src="../../../../../assets/icons/chevron-right-small.svg" />
                        </div>
                        <div class="card-row d-flex justify-content-between align-items-center">
                            <span class="label">Account Number</span>
                            <span class="value">{{ customer.accountNumber | hasValue }}</span>
                        </div>
                        <div class="card-row d-flex justify-content-between align-items-center">
                            <span class="label">Meter Number</span>
                            <span class="value">{{ customer.meterNumber | hasValue}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>